import Header from './Header';
import Footer from './Footer';
import LeftSidebar from './LeftSidebar';
import RightSidebar from './RightSidebar';

export default function Layout({ children }) {

  return (
    <>
      <Header />
      <main className="columnLayout">
      <div className="container">
        <LeftSidebar />
        <div className="mainContaint">
          <div className="main-wrapper">{children}</div>
        </div>
        <RightSidebar />
      </div>
      </main>
      {/* <Footer /> */}
    </>
  );
}
